export enum SocketHandlerResponseTypes {
  None = 0,
  GetCurrentDateTime = 4,
  NewNotification = 8,
  NewChatBotMessage = 9,
  NewChatTitle = 10,
}
